"use client";

// Last-resort error boundary when the root layout fails — must render its own html/body.

export default function RootLayoutError({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="pt-BR">
      <body style={{ margin: 0, fontFamily: "system-ui, sans-serif" }}>
        <main
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "24px", fontWeight: 300, marginBottom: "16px" }}>
            Algo deu errado
          </h1>
          <p style={{ fontSize: "15px", color: "#666", maxWidth: "400px" }}>
            Ocorreu um erro inesperado. Tente recarregar a página.
          </p>
          <button
            onClick={reset}
            style={{
              marginTop: "24px",
              padding: "10px 20px",
              fontSize: "14px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            Tentar novamente
          </button>
        </main>
      </body>
    </html>
  );
}
